import * as Yup from "yup";
import { type AccountTypeEnum } from "../../graphql/supergraphTypes";
import { extendedEntityAccountTypes } from "../../utils/account_types";

export const createAccountTypeSchema = (showExtendedTypes: boolean) =>
  Yup.object({
    accountType: Yup.mixed<AccountTypeEnum>()
      .required("Please select an account type")
      .test(
        "extended-type-validation",
        "Please select a valid account type from the visible options",
        function (value) {
          if (!showExtendedTypes && extendedEntityAccountTypes.has(value)) {
            return false;
          }

          return true;
        },
      ),
  });
